import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'
import { AuthService } from './auth.service'
import { from, switchMap } from 'rxjs'
import { environment } from '../../../environments/environment'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)

  // Skip interceptor for non-API requests
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req)
  }

  // Add Authorization header with ID token
  return from(authService.getIdToken()).pipe(
    switchMap((token) => {
      if (token) {
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
        return next(clonedReq)
      }
      return next(req)
    })
  )
}
